import React from 'react';

import {
  FloatingFocusManager,
  FloatingPortal,
  UseFloatingReturn,
} from '@floating-ui/react';

import Overlay from '@adsk/alloy-react-overlay';
import { StyleProp } from '@adsk/alloy-react-theme';

import { DATE_PICKER_VARIANTS } from '../consts';
import TriggerWrapper from './TriggerWrapper';

type PickerOverlayPortalProps = {
  className?: string;
  style?: StyleProp;
  container: React.ComponentProps<typeof FloatingPortal>['root'];
  open: boolean;
  context: UseFloatingReturn['context'];
  targetProps: Record<string, unknown>;
  placement: UseFloatingReturn['placement'];
  getTriggerProps: () => Record<string, unknown>;
  arrowProps: Record<string, unknown>;
  overlayContainerProps: Record<string, unknown>;
  arrowColor?: string;
  variant: (typeof DATE_PICKER_VARIANTS)[keyof typeof DATE_PICKER_VARIANTS];
  renderTrigger: (props: Record<string, unknown>) => React.ReactNode;
  renderOverlay: () => React.ReactNode;
};

const PickerOverlayPortal = ({
  className,
  style,
  container,
  open,
  context,
  targetProps,
  placement,
  getTriggerProps,
  arrowProps,
  overlayContainerProps,
  arrowColor,
  variant,
  renderTrigger,
  renderOverlay,
}: PickerOverlayPortalProps) => (
  <>
    <TriggerWrapper
      className={className}
      css={style !== null ? style : undefined}
      {...targetProps}
    >
      {renderTrigger({ ...getTriggerProps() })}
    </TriggerWrapper>
    <FloatingPortal root={container}>
      {open && (
        <FloatingFocusManager context={context} modal={false}>
          <div {...overlayContainerProps}>
            {variant === DATE_PICKER_VARIANTS.ICON && (
              <Overlay.Arrow
                placement={placement}
                color={arrowColor}
                {...arrowProps}
              />
            )}
            {renderOverlay()}
          </div>
        </FloatingFocusManager>
      )}
    </FloatingPortal>
  </>
);

export default PickerOverlayPortal;
